// T3/100A04: bloqueo por URL de los módulos sin permiso. Solo con REACT_APP_SEC_ROUTE_GUARD=true
// (sin la variable la app se comporta igual que antes). La seguridad real está en el servidor
// (p. ej. SEC_CRM_ACCESS, T3/100A03); esto evita que la pantalla se abra escribiendo la URL.
import React, { useEffect, useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spin, message } from "antd";
import { usePermiso } from "components/Permisos/PermisosContext";
import { buildRouteIndex, routeDecision } from "./routeAccess";

const RouteGuard = ({ children }) => {
  const { pathname } = useLocation();
  const { status, superadmin, allow } = usePermiso();
  const index = useMemo(() => buildRouteIndex(), []);
  const decision = routeDecision({ pathname, status, superadmin, allow, index });

  useEffect(() => {
    if (decision !== "deny") return;
    console.warn(`[SEGURIDAD] Acceso bloqueado por permiso a ${pathname}`);
    message.warning("No tiene permiso para este módulo");
  }, [decision, pathname]);

  if (decision === "wait") return <Spin><div style={{ width: "100%", height: "100vh" }} /></Spin>;
  if (decision === "deny") return <Navigate to="/" replace />;
  return children;
};

export default RouteGuard;
